import { Alert } from '@isyc-react/design/bootstrap';
import React from 'react';
export const DossierErrors = props => {
    const { errors } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Alert, { show: true, dismissible: false, variant: 'warning' },
            React.createElement(Alert.Heading, { className: '' }, "Des erreurs ont \u00E9t\u00E9 trouv\u00E9es"),
            errors.map((error, i) => (React.createElement("p", { key: i }, error))))));
};
